import Axios from 'axios';

export default {
  getIgnoredReasons() {
    return Axios.get('/admin/bills/ignored-reasons')
      .then(({ data }) => data);
  },

  getStudentBills(contractsIds) {
    return Axios.get('/admin/bills', {
      params: {
        contract_ids: contractsIds,
      },
    })
      .then(({ data }) => data);
  },

  getBill(billId) {
    return Axios.get(`/admin/bills/${billId}`)
      .then(({ data }) => data);
  },

  changeBillDueDate(billId, newDueDate) {
    return Axios.put(`/admin/bills/${billId}/change-due-date`, { new_due_date: newDueDate })
      .then(({ data }) => data);
  },

  changeBillValue(billId, newFullAmount) {
    return Axios.put(`/admin/bills/${billId}`, { full_amount_cents: newFullAmount })
      .then(({ data }) => data);
  },

  disableCharges(billId) {
    return Axios.put(`/admin/bills/${billId}/disable-charges`)
      .then(({ data }) => data);
  },

  enableCharges(billId) {
    return Axios.put(`/admin/bills/${billId}/enable-charges`)
      .then(({ data }) => data);
  },

  ignoreBill(billId, observations, ignoredReasonKey) {
    return Axios.put(`/admin/bills/${billId}/ignore`, {
      observations,
      ignored_reason_key: ignoredReasonKey,
    })
      .then(({ data }) => data.response);
  },

  cancelBill(billId, observations) {
    return Axios.put(`/admin/bills/${billId}/cancel`, { observations })
      .then(({ data }) => data);
  },

  generateBoleto(billId, expiryDate, extraRecipient) {
    return Axios.put(`/admin/bills/${billId}/generate-boleto`, {
      expiry_date: expiryDate,
      extra_recipient: extraRecipient,
    })
      .then(({ data }) => data);
  },

  diluteBill(billId, billsIdsToReceiveValue, observations) {
    return Axios.put(`/admin/bills/${billId}/dilute-value`, {
      bills_ids_to_receive_value: billsIdsToReceiveValue,
      observations,
    })
      .then(({ data }) => data);
  },

  createBill(params) {
    return Axios.post('/admin/bills', params)
      .then(({ data }) => data);
  },

  paymentDetails(billId) {
    return Axios.get(`/admin/bills/${billId}/payment-details`)
      .then(({ data }) => data);
  },

  processPayments(billId, observations) {
    return Axios.post(`/admin/bills/${billId}/process-payments`, {
      observations,
    })
      .then(({ data }) => data);
  },

  processPaymentsTransferingDebt(billId, billToReceiveAmountId, observations) {
    return Axios.post(`/admin/bills/${billId}/process-payments-transfering-debt`, {
      bill_to_receive_amount_id: billToReceiveAmountId,
      observations,
    })
      .then(({ data }) => data);
  },

  processPaymentsForgivingDebt(billId, observations) {
    return Axios.post(`/admin/bills/${billId}/process-payments-forgiving-debt`, {
      observations,
    })
      .then(({ data }) => data);
  },

  reactivateBill(billId, observations) {
    return Axios.put(`/admin/bills/${billId}/reactivate`, { observations })
      .then(({ data }) => data);
  },

  editExternalId(billId, newExternalId) {
    return Axios.put(`/admin/bills/${billId}/edit-external-id`, { external_id: newExternalId })
      .then(({ data }) => data);
  },
};
